import React, { Component } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "../../../components/admin/css/common.css";
import {sweetStatusAlert} from "../../../components/common/SweetAlert.js";
import Spinner from "react-bootstrap/Spinner";
import PageSpinner from "../../../components/common/spinner/PageSpinner.js";
import moment from "moment";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Checkbox,
  Autocomplete,
  TextField
} from "@mui/material";
import MaterialCustomTablePagination from "../../../components/common/MaterialCustomTablePagination.js";
import debounce from "lodash.debounce";
import SimpleReactValidator from "simple-react-validator";
import { candidateService } from "../../../service/settings/candidate/candidateService.js";
import { libraryService } from "../../../service/assessment/libraryService.js";
import { assessmentService } from "../../../service/assessment/assessmentService";
import { manageUserService } from "../../../service/user_management/manage.user.service.js";
import ContentWrapper from "../../../components/common/ContentWrapper.js";
import config from '../../../helper/config.js';
import {customerConstants} from "../../../helper/constants.js";
import { PAPER_SETTINGS_FILTERS } from "../../../helper/constants.js";
import { CMC_PAPER_SETTINGS_FILTERS } from "../../../helper/constants.js";
import ModalBody from "../../../components/common/modal/ModalBody";
import ModalHeader from "../../../components/common/modal/ModalHeader";
import ViewForm from "../../../components/common/form/Form";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import {Box, Chip, CircularProgress, IconButton} from "@mui/material";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FormControlLabel from "@mui/material/FormControlLabel";
import PaperListChips from "../../manage/paper/edsider/FindPaperTabs/PaperListChips.js";
import Tooltip from "@mui/material/Tooltip";
import ClearIcon from '@mui/icons-material/Clear';
import ChevronLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ChevronRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import PaperFilterLayout from "../../manage/paper/edsider/TheFilter/PaperFilterLayout.js";
import { EMPLOYEE_FILTERS } from "../../../helper/constants.js";            
import { select } from "underscore";
import StickyCardBody from "../../../components/common/StickyCardBody.js";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle, privilegeEditEnabled, isCMC, gradeText, FILTERS;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    isCMC = false;
    gradeText = "Grade";
    FILTERS = PAPER_SETTINGS_FILTERS;
    privilegeEditEnabled = false;
    break;
  case customerConstants.EXO_CUSTOMER2:
    isCMC = true;
    gradeText = "Year";
    FILTERS = CMC_PAPER_SETTINGS_FILTERS;
    privilegeEditEnabled = false;
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent",
    };
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent",
    };
    break;
  default:
    isCMC = false;
    gradeText = "Grade";
    FILTERS = PAPER_SETTINGS_FILTERS;
    privilegeEditEnabled = true;
    break;
}

export default class extends Component {
  constructor(props) {
    super(props);
    this.createValidationsInstance();
    this.state = {
      papers: [],
      limit: 300, // Set the desired limit
      offset: 0, // Set the desired offset
      search_term: "",
      sort_column: "created_at",
      sort_direction: "DESC",
      selectedCategories: null,
      selectedAuthors: null,
      selectedChapters: null,
      selectedGrades: null,
      selectedDifficulties: null,
      selectedLanguages: null,
      selectedTerms: null,
      selectedYears: null,
      selectedsubjects: null,
      selectedStatuses: null,
      selectedCreators: null,
      selectedExamCategories: null,
      selectedSources: null,
      teachers: [],
      checked: false,
      totalCount: 300,
      isTableDataLoading: true,
      currentPage: 0,
      isLoading: false,
      allCategories: [],
      allLanguages: [],
      allSubjects: [],
      allAuthors: [],
      allYears: [],
      allDifficulties: [],
      allGrades: [],
      allTerms: [],
      allChapters: [],
      allPrivileges: [],
      teacherDropdown: [],
      allExamCategories: [],
      allCreators: [],
      allSources: [],
      gradeCounts: [],
      subjectCounts: [],
      languageCounts: [],
      examCategoryCounts: [],
      sourceCounts: [],
      authorCounts: [],
      createdByCounts: [],
      categoryCounts: [],
      difficultyCounts: [],
      chapterCounts: [],
      yearCounts: [],
      termCounts: [],
      statusCounts: [],
      selectSearchTerm: "",
      selectedPapers: [],
      selectedPaper: "",
      selectAll: false,
      filterValues: [],
      filters: [],
      selectedFilters: [],
      editCategoryId: null,
      editGradeId: null,
      editLanguageId: null,
      editSubjectId: null,
      editChapterId: null,
      editDifficultyId: null,
      editAuthorId: null,
      editYearId: null,
      editTermId: null,
      editPrivilegeId: null,
      editStatusId: null,
      editSourceId: null,
      editExamCategoryId: null,
      editStatusName: null,
      isAllReady: false,
      selectedStartDate: null,
      selectedEndDate: null,
    };

    // Debounced version of handleSearch function
    this.debouncedHandleSearch = debounce(this.fetchAllPapers, 3000);
  }

  // Reset the form fields to initail values on update, insert, edit modal close and add modal close
  resetFormFields = () => {
    this.setState({
      editCategoryId: null,
      editGradeId: null,
      editLanguageId: null,
      editSubjectId: null,
      editChapterId: null,
      editDifficultyId: null,
      editAuthorId: null,
      editYearId: null,
      editTermId: null,
      editPrivilegeId: null,
      editSourceId: null,
      editExamCategoryId: null,
      editStatusId: null,
      editStatusName: null,
      isAllReady: false
    });
  };

  componentDidMount() {
    this.fetchAllAssessmentMetaData();
    this.fetchEmployeesForDropdown();
    this.fetchAllPapers();
  }

  // Creating validator instance
  createValidationsInstance() {
    this.validator = new SimpleReactValidator({
      validators: {
        customMin: {
          message: "The :attribute value must be greater than :min.",
          rule: (val, params) => {
            return parseInt(val, 10) > params[0];
          },
          messageReplace: (message, params) => message.replace(':min', params[0]),
          required: true
        }
      }
    });
  }

  fetchEmployeesForDropdown = async () => {
    try {
      const teacherRoles = ["TEACH", "MASAD"];  
      // Fetch teachers and main assessment admin for teacher roles
      const teacherResponse = await manageUserService.getTeachersforDropdown(teacherRoles);
  
      if (teacherResponse.success) {
        this.setState({
          teacherDropdown: teacherResponse.data,
        });
      } else {
        this.setState({
          teacherDropdown: [],
        });
      }
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
      this.setState({
        teacherDropdown: [],
      });
    } finally {
      this.setState({
        isTableDataLoading: false,
      });
    }
  };

  fetchAllAssessmentMetaData  = async () => {
    this.setState({
      isTableDataLoading: true,
    });

    const fetchAssessmentMetaData =
      await assessmentService.getAllAssessmentMetaData();

    await Promise.all([fetchAssessmentMetaData])
      .then((response) => {
        const [assessmentMetaDataResponse] = response;

        this.setState({
          allCategories: assessmentMetaDataResponse.data.find(
            (item) => "categories" in item
          ).categories,
          allLanguages: assessmentMetaDataResponse.data.find(
            (item) => "languages" in item
          ).languages,
          allSubjects: assessmentMetaDataResponse.data.find(
            (item) => "subjects" in item
          ).subjects,
          allAuthors: assessmentMetaDataResponse.data.find(
            (item) => "authors" in item
          ).authors,
          allYears: assessmentMetaDataResponse.data.find(
            (item) => "years" in item
          ).years,
          allDifficulties: assessmentMetaDataResponse.data.find(
            (item) => "difficulty_types" in item
          ).difficulty_types,
          allGrades: assessmentMetaDataResponse.data.find(
            (item) => "grades" in item
          ).grades,
          allTerms: assessmentMetaDataResponse.data.find(
            (item) => "terms" in item
          ).terms,
          allChapters: assessmentMetaDataResponse.data.find(
            (item) => "chapters" in item
          ).chapters,
          allPrivileges: assessmentMetaDataResponse.data.find(
            (item) => "privileges" in item
          ).privileges,
          allAssessmentStatuses: assessmentMetaDataResponse.data.find(
            (item) => "statuses" in item
          ).statuses,
          allExamCategories: assessmentMetaDataResponse.data.find(
            (item) => "exam_categories" in item
          ).exam_categories,
          allCreators: assessmentMetaDataResponse.data.find(
            (item) => "creators" in item
          ).creators,
          allSources: assessmentMetaDataResponse.data.find(
            (item) => "sources" in item
          ).sources,
          isTableDataLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          isTableDataLoading: false,
        });
      });
  }

  getPaperCategory(category_id) {
    if (category_id !== null) {
        const category = this.state.allCategories?.find(
            (category) => category.category_id == category_id
        );
        return category?.name;
    }
    else{
        return "N/A";
    }
  }

  getPaperLanguage(language_id) {
    if (language_id !== null) {
        const language = this.state.allLanguages?.find(
            (language) => language.language_id == language_id
        );
        return language?.language;
    }
    else{
        return "N/A";
    }
  }

  getPaperSubject(subject_id) {
    if (subject_id !== null) {
        const subject = this.state.allSubjects?.find(
            (subject) => subject.subject_id == subject_id
        );
        return subject?.subject;
    }
    else{
        return "N/A";
    }
  }

  getPaperAuthor(author_id) {
    if (author_id !== null) {
        const author = this.state.allAuthors?.find(
            (author) => author.author_id == author_id
        );
        return author?.author;
    }
    else{
        return "N/A";
    }
  }

  getPaperYear(year_id) {
    if (year_id !== null) {
        const year = this.state.allYears?.find(
            (year) => year.year_id == year_id
        );
        return year?.year;
    }
    else{
        return "N/A";
    }
  }

  getPaperDifficulty(difficulty_id) {
    if (difficulty_id !== null) {
        const difficulty = this.state.allDifficulties?.find(
            (difficulty) => difficulty.difficulty_id == difficulty_id
        );
        return difficulty?.difficulty_type;
    }
    else{
        return "N/A";
    }
  }

  getPaperGrade(grade_id) {
    if (grade_id !== null) {
        const grade = this.state.allGrades?.find(
            (grade) => grade.grade_id == grade_id
        );
        return grade?.grade;
    }
    else{
        return "N/A";
    }
  }

  getPaperTerm(term_id) {
    if (term_id !== null) {
        const term = this.state.allTerms?.find(
            (term) => term.term_id == term_id
        );
        return term?.term;
    }
    else{
        return "N/A";
    }
  }

  getCreatedAtLocal(time) {
    if(time != null){
        let timeStamp = new Date(time.concat("Z"))
        let d = new Date(timeStamp)
        // let startDate = d.toDateString();
        // let startTime = d.toLocaleTimeString('en-SL');
        let  local = moment(timeStamp).local().format("MMMM Do YYYY hh:mm A")
        return local;
    }
    else{
        return "N/A";
    }
  }

  getPaperChapter(chapter_id) {
    if (chapter_id !== null) {
        const chapter = this.state.allChapters?.find(
            (chapter) => chapter.chapter_id == chapter_id
        );
        return chapter?.chapter;
    }
    else{
        return "N/A";
    }
  }

  getPaperStatus(status_id) {
    if (status_id !== null) {
        const status = this.state.allAssessmentStatuses?.find(
            (status) => status.status_id == status_id
        );
        return status?.status;
    }
    else{
        return "N/A";
    }
  }

  getPaperExamCategory(exam_category_id) {
    if (exam_category_id !== null) {
        const exam_category = this.state.allExamCategories?.find(
            (exam_category) => exam_category.exam_category_id == exam_category_id
        );
        return exam_category?.name;
    }
    else{
        return "N/A";
    }
  }

  getPaperSource(source_id) {
    if (source_id !== null) {
        const source = this.state.allSources?.find(
            (source) => source.source_id == parseInt(source_id)
        );
        return source?.source;
    }
    else{
        return "N/A";
    }
  }

  getPaperTeacherName(teacher_id) {
    if (teacher_id !== null) {
        const teacher = this.state.teacherDropdown?.find(
            (teacher) => teacher.user_id == teacher_id
        );
        return teacher?.first_name + " " + teacher?.last_name;
    }
    else{
        return "N/A";
    }
  }

  fetchAllPapers = async () => {
    const { 
      limit, 
      offset, 
      sort_column, 
      sort_direction, 
      search_term, 
      selectedCategories,
      selectedAuthors,
      selectedChapters,
      selectedGrades,
      selectedDifficulties,
      selectedLanguages,
      selectedTerms,
      selectedYears,
      selectedsubjects,
      selectedStatuses,
      selectedCreators,
      selectedExamCategories,
      selectedSources,
      selectedStartDate,
      selectedEndDate,
    } = this.state;
    this.setState({ isTableDataLoading: true })
    await libraryService.getAllPapers(
        limit,
        offset,
        sort_column,
        sort_direction,
        search_term,
        selectedCategories,
        selectedAuthors,
        selectedChapters,
        selectedGrades,
        selectedDifficulties,
        selectedLanguages,
        selectedTerms,
        selectedYears,
        selectedsubjects,
        selectedStatuses,
        selectedCreators,
        selectedExamCategories,
        selectedSources,
        selectedStartDate,
        selectedEndDate,
    ).then((response) => {
        if (response.success) {
          this.setState({
            papers: response.data.papers,
            totalCount: parseInt(response.data.total_count),
            teachers: response.data.teachers,
            gradeCounts: response.data.grade_counts,
            subjectCounts: response.data.subject_counts,
            languageCounts: response.data.language_counts,
            examCategoryCounts: response.data.exam_category_counts,
            sourceCounts: response.data.source_counts,
            authorCounts: response.data.author_counts,
            categoryCounts: response.data.category_counts,
            difficultyCounts: response.data.difficulty_counts,
            chapterCounts: response.data.chapter_counts,
            yearCounts: response.data.year_counts,
            termCounts: response.data.term_counts,
            statusCounts: response.data.status_counts,
            createdByCounts: response.data.created_by_counts,
          });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching all papers. Please refresh the screen!",
            "error"
          );
        }
      })
      .catch((error) => {
        // Handle any error that occurred during the API call
        sweetStatusAlert(
          "Failed!",
          "Error fetching all papers. Please refresh the screen!",
          "error"
        );
      })
      .finally(() => {
        this.setState({ isTableDataLoading: false }); // Set isTableDataLoading to false after data is fetched
      });
  };

  handleSortChange = (sort_column) => {
    // If the same column is clicked, toggle the sort direction
    const { sort_column: currentSortColumn, sort_direction } = this.state;
    const newSortDirection =
      currentSortColumn === sort_column && sort_direction === "ASC"
        ? "DESC"
        : "ASC";

    this.setState(
      {
        sort_column,
        sort_direction: newSortDirection,
        offset: 0, // Reset offset when changing sorting
        currentPage: 0,
        isTableDataLoading: true,
      },
      () => {
       this.fetchAllPapers();
      }
    );
  };

  // Handle the data fetching as per the offset(page no) changes
  handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchAllPapers();
      }
    );
  };

  handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage
      },
      () => {
        this.fetchAllPapers();
      }
    );
  };

  // handle the data fetching as per the data per page limit gets changess
  handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
      {
        limit: newLimit,
        offset: newLimit * newPage,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchAllPapers();
      }
    );
  };

  // handle search text as per the regex validation and search_term , and fetch data as per the debounce
  handleSearch = (event) => {
    const search_term = event.target.value.trim();
    //const regex = /^[\w\s\d@&.,:;!?()\-_/\\[\]{}'"|#*~+=%$^<>]*$/;
    const regex = /^[\p{L}\p{M}\p{N}\p{P}\p{S}\s]*$/u;


    if (search_term === "" || regex.test(search_term)) {
      this.setState(
        {
          search_term,
          isTableDataLoading: true,
          offset: 0,
          currentPage: 0,
          searchError: false,
        },
        () => {
          this.debouncedHandleSearch();
        }
      );
    } else {
      this.setState({ search_term, searchError: true });
    }
  };
  
    handleFilterChange = (newSelectedFilters) => {

    const getOrNull = (key) =>
      newSelectedFilters[key] && newSelectedFilters[key].length > 0
        ? newSelectedFilters[key]
        : null;

    this.setState(
      {

    selectedCategories: getOrNull("Category"),
    selectedAuthors: getOrNull("Author"),
    selectedChapters: getOrNull("Chapter"),
    selectedGrades: getOrNull("Grade"),
    selectedDifficulties: getOrNull("Difficulty"),
    selectedLanguages: getOrNull("Language"),
    selectedTerms: getOrNull("Term"),
    selectedYears: getOrNull("Year"),
    selectedsubjects: getOrNull("Subject"),
    selectedExamCategories: getOrNull("Exam_Category"),
    selectedStatuses: getOrNull("Status"),
    selectedCreators: getOrNull("Created_By"),
    selectedSources: getOrNull("Source"),
    selectedStartDate:getOrNull("StartDate"),
    selectedEndDate:getOrNull("EndDate"),

    offset: 0,
    currentPage: 0,
   
      },
      () => {
        this.fetchAllPapers();
      }
    );
  };
  //New Multi Filter
  onSelectFilterMulti = (selectedItem) => {    

    const { filterValues } = this.state;

    let updatedFilterValues = [...filterValues];

    const index = updatedFilterValues.findIndex(
      (item) =>
        item.filter === selectedItem.filter &&
        item[`${selectedItem.filter.toLowerCase()}_id`] === selectedItem[`${selectedItem.filter.toLowerCase()}_id`]
    );


    if (index === -1) {

      updatedFilterValues.push(selectedItem);

    } else {

      updatedFilterValues.splice(index, 1);
    }


    this.onSelectFilterMultiProcess(updatedFilterValues);
  };

  onSelectFilterMultiProcess = (filterValues) => {

    const filterMap = {
      Category: [],
      Created_By: [],
      Difficulty: [],
      Language: [],
      Subject: [],
      Author: [],
      Year: [],
      Term: [],
      Chapter: [],
      Grade: [],
      Status: [],
      Exam_Category: [],
      Source: [],
    };

    filterValues.forEach((val) => {
      const filterType = val.filter;
      if (filterType && filterMap.hasOwnProperty(filterType)) {
        switch (filterType) {
          case "Category":
            filterMap.Category.push(val?.category_id);
            break;
          case "Created_By":
            filterMap.Created_By.push(val?.created_by_id);
            break;
          case "Difficulty":
            filterMap.Difficulty.push(val?.difficulty_id);
            break;
          case "Language":
            filterMap.Language.push(val?.language_id);
            break;
          case "Subject":
            filterMap.Subject.push(val?.subject_id);
            break;
          case "Author":
            filterMap.Author.push(val?.author_id);
            break;
          case "Year":
            filterMap.Year.push(val?.year_id);
            break;
          case "Term":
            filterMap.Term.push(val?.term_id);
            break;
          case "Chapter":
            filterMap.Chapter.push(val?.chapter_id);
            break;
          case "Grade":
            filterMap.Grade.push(val?.grade_id);
            break;
          case "Status":
            filterMap.Status.push(val?.status_id);
            break;
          case "Exam_Category":
            filterMap.Exam_Category.push(val?.exam_category_id);
            break;
          case "Source":
            filterMap.Source.push(val?.source_id);
            break;
          default:
            break;
        }
      }
    });

    this.setState(
      {
        filterValues,
        selectedAuthors: filterMap.Author.length > 0 ? filterMap.Author : null,
        selectedsubjects: filterMap.Subject.length > 0 ? filterMap.Subject : null,
        selectedChapters: filterMap.Chapter.length > 0 ? filterMap.Chapter : null,
        selectedTerms: filterMap.Term.length > 0 ? filterMap.Term : null,
        selectedCategories:
          filterMap.Category.length > 0 ? filterMap.Category : null,
        selectedYears: filterMap.Year.length > 0 ? filterMap.Year : null,
        selectedLanguages:
          filterMap.Language.length > 0 ? filterMap.Language : null,
        selectedDifficulties:
          filterMap.Difficulty.length > 0 ? filterMap.Difficulty : null,
        selectedGrades: filterMap.Grade.length > 0 ? filterMap.Grade : null,
        selectedStatuses: filterMap.Status.length > 0 ? filterMap.Status : null,
        selectedCreators: filterMap.Created_By.length > 0 ? filterMap.Created_By : null,
        selectedExamCategories: filterMap.Exam_Category.length > 0 ? filterMap.Exam_Category : null,
        selectedSources: filterMap.Source.length > 0 ? filterMap.Source : null,
      },
      () => {
        this.fetchAllPapers();
      }
    );
  };

  isParentChecked = (filterType) => {
    const filterValues = this.state.filterValues;
    const childItems = this.getChildItems(filterType);
    return (
      childItems.length > 0 &&
      childItems.every((child) =>
        filterValues.some(
          (selectedItem) =>
            selectedItem.filter === filterType &&
            selectedItem[`${filterType.toLowerCase()}_id`] ===
            child[`${filterType.toLowerCase()}_id`]
        )
      )
    );
  };

  isParentIndeterminate = (filterType) => {
    const filterValues = this.state.filterValues;
    const childItems = this.getChildItems(filterType);
    const selectedCount = childItems.filter((child) =>
      filterValues.some(
        (selectedItem) =>
          selectedItem.filter === filterType &&
          selectedItem[`${filterType.toLowerCase()}_id`] ===
          child[`${filterType.toLowerCase()}_id`]
      )
    ).length;
    return selectedCount > 0 && selectedCount < childItems.length;
  };

  handleParentCheckboxChange = (filterType, filterItems) => {
    const filterValues = [...this.state.filterValues];
    const childItems = filterItems

    const allSelected = this.isParentChecked(filterType);
    

    let updatedFilterValues;
    if (allSelected) {

      updatedFilterValues = filterValues.filter(
        (item) => item.filter !== filterType
      );
    } else {

      const newSelections = childItems.map((child) => ({
        filter: filterType,
        name: child.name,
        [`${filterType.toLowerCase()}_id`]: child[`${filterType.toLowerCase()}_id`],
      }));
      updatedFilterValues = [
        ...filterValues.filter((item) => item.filter !== filterType),
        ...newSelections,
      ];
    }


    this.onSelectFilterMultiProcess(updatedFilterValues);
  };

  getChildItems = (filterType) => {
    switch (filterType) {
      case "Category":
        return this.state.allCategories || [];
      case "Created_By":
        return this.state.allCreators || [];
      case "Difficulty":
        return this.state.allDifficulties || [];
      case "Language":
        return this.state.allLanguages || [];
      case "Subject":
        return this.state.allSubjects || [];
      case "Author":
        return this.state.allAuthors || [];
      case "Year":
        return this.state.allYears || [];
      case "Grade":
        return this.state.allGrades || [];
      case "Term":
        return this.state.allTerms || [];
      case "Chapter":
        return this.state.allChapters || [];
      case "Status":
        return this.state.allAssessmentStatuses || [];
      case "Exam_Category":
        return this.state.allExamCategories || [];
      case "Source":
        return this.state.allSources || [];
      default:
        return [];
    }
  };

  clearAllFilters = () => {
    this.setState(
      {
        filterValues: [],
        selectedAuthors: null,
        selectedsubjects: null,
        selectedChapters: null,
        selectedTerms: null,
        selectedCategories: null,
        selectedYears: null,
        selectedLanguages: null,
        selectedDifficulties: null,
        selectedGrades: null,
        selectedStatuses: null,
        selectedCreators: null,
        selectedExamCategories: null,
        selectedSources: null,
      },
      () => {
        this.fetchAllPapers();
      }
    );
  };

  handleBulkClose = () => {
    this.setState({
      showUpdateBulkDetailModal: false
    });
    this.validator.hideMessages();
    this.validator.purgeFields();
    this.resetFormFields();
  }

  toggleUpdateBulkPaperModal = () => {
    this.setState((prevState) => ({
      showUpdateBulkDetailModal: !prevState.showUpdateBulkDetailModal,
    }));
  };

  handleViewClick = (paperItem) => {
    this.setState({
      selectedPaper: paperItem,  
      showDetailModal: true, 
    });
  };
  
  toggleDetailModal = () => {
    this.setState((prevState) => ({
      showDetailModal: !prevState.showDetailModal,
    }));
  };

  handleChangeCategory = (e) => {
    e.preventDefault();
    const editCategoryId = e.target.value;
    this.setState({ editCategoryId });
  };

  handleChangeGrade = (e) => {
    e.preventDefault();
    const editGradeId = e.target.value;
    this.setState({ editGradeId });
  };

  handleChangeLanguage = (e) => {
    e.preventDefault();
    const editLanguageId = e.target.value;
    this.setState({ editLanguageId });
  };

  handleChangeChapter = (e) => {
    e.preventDefault();
    const editChapterId = e.target.value;
    this.setState({ editChapterId });
  };

  handleChangeSubject = (e) => {
    e.preventDefault();
    const editSubjectId = e.target.value;
    this.setState({ editSubjectId });
  };

  handleChangeDifficulty = (e) => {
    e.preventDefault();
    const editDifficultyId = e.target.value;
    this.setState({ editDifficultyId });
  };

  handleChangeAuthor = (e) => {
    e.preventDefault();
    const editAuthorId = e.target.value;
    this.setState({ editAuthorId });
  };

  handleChangeYear = (e) => {
    e.preventDefault();
    const editYearId = e.target.value;
    this.setState({ editYearId });
  };

  handleChangeTerm = (e) => {
    e.preventDefault();
    const editTermId = e.target.value;
    this.setState({ editTermId });
  };

  handleChangePrivilege = (e) => {
    e.preventDefault();
    const editPrivilegeId = e.target.value;
    this.setState({ editPrivilegeId });
  };

  handleChangeSource = (e) => {
    e.preventDefault();
    const editSourceId = e.target.value;
    this.setState({ editSourceId });
  };

  handleChangeExamCategory = (e) => {
    e.preventDefault();
    const editExamCategoryId = e.target.value;
    this.setState({ editExamCategoryId });
  };

  handleChangeStatus = (e) => {
    e.preventDefault();
    const editStatusId = e.target.value;
    const editStatusName = this.getPaperStatus(parseInt(e.target.value, 10));
    this.setState({ editStatusId });
    this.setState({ editStatusName });
  };

  handleUpdateBulkSubmit = async (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      this.setState({ isLoading: true });

      const paperItem = {
        paper_list: this.state.selectedPapers,
        category_id: this.state.editCategoryId,
        grade_id: this.state.editGradeId,
        language_id: this.state.editLanguageId,
        chapter_id: this.state.editChapterId,
        subject_id: this.state.editSubjectId,
        difficulty_id: this.state.editDifficultyId,
        author_id: this.state.editAuthorId,
        year_id: this.state.editYearId,
        term_id: this.state.editTermId,
        privilege_id: this.state.editPrivilegeId,
        status_id: this.state.editStatusId,
        source_id: parseInt(this.state.editSourceId),
        exam_category_id: this.state.editExamCategoryId,
        assessment_state: this.state.editStatusName
      };

      await candidateService.updateAllPapers(paperItem)
        .then((response) => {
          this.setState({ isLoading: false, selectedPapers: [], selectAll: false });
          if (response.success) {
            this.setState({ showUpdateBulkDetailModal: false });
            sweetStatusAlert(
              "Success!",
              "Selected papers updated successfully!",
              "success"
            );
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            this.fetchAllPapers();
          } else {
            sweetStatusAlert("Failed!", response.message, "error");
          }
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          sweetStatusAlert(
            "Failed !",
            "Unable to update the selected papers!",
            "error"
          );
        });
    }
  };

  getColor(state) {
    switch (state) {
      case "Initial":
        return "label label-lg label-light-primary label-inline";
      case "Ready":
        return "label label-lg label-light-warning label-inline";
      case "Review":
        return "label label-lg label-light-default label-inline";
      case "Published":
        return "label label-lg label-success label-inline";
      case "Retired":
        return "label label-lg label-light-danger label-inline";
      case "InReview":
        return "label label-lg label-light-info label-inline"; 
      case "ReferBack":
        return "label label-lg label-light-danger label-inline";
      case "ReviewCompleted":
        return "label label-lg label-light-warning label-inline"; 
      default:
        return "label label-lg label-light-info label-inline";
    }
  }
  
  handleSelect = (assessment_id) => {
    this.setState((prevState) => {
      const { selectedPapers} = prevState;
      if (selectedPapers.includes(assessment_id)) {
        return {
          selectedPapers: selectedPapers.filter((id) => (id !== assessment_id)),
        };
      } else {
        return {
          selectedPapers: [...selectedPapers, assessment_id],
        };
      }
    });
    const isAll = this.state.selectedPapers.every(paper => paper.status_id === 2)
    if(isAll){
      this.setState({ isAllReady : true });
    }
  };

  handleSelectAll = () => {
    const { selectAll, papers } = this.state;
    const isAll = papers.every(paper => paper.status_id === 2)
    if(isAll){
      this.setState({ isAllReady : true });
    }
    if (selectAll) {
      this.setState({ selectedPapers: [], selectAll: false });
    } else {
      const allIds = papers.map((item) => item.assessment_id);
      this.setState({ selectedPapers: allIds, selectAll: true });
    }
  };

  handleSelectMyPapers = (e) => {
    const isChecked = e.target.checked;
    this.setState(
      {
        checked: isChecked,  
        selectedCreators: isChecked ? sessionStorage.getItem("user_id") : null  
      },
      () => {
        this.fetchAllPapers();  
      }
    );
  };

  handleStartDateChange = (event) => {
      const date = event.target.value;
      const formattedDate = date ? date.replace(/-/g, "") : null;
      this.setState({ selectedStartDate : formattedDate},
          () =>{
            this.fetchAllPapers();  
          }
      )
  };
    
  handleEndDateChange = (event) => {
      const date = event.target.value;
      const formattedDate = date ? date.replace(/-/g, "") : null;
      this.setState({ selectedEndDate : formattedDate},
          () => {
            this.fetchAllPapers();  
          }
      )
  };

  clearDateRange = () => {
      this.setState({ selectedStartDate : "", selectedEndDate : "" },
        () =>{
          this.setState({ selectedStartDate : null, selectedEndDate : null },
            () => {
              this.fetchAllPapers();  
            }
          );
        }
      );
  };

  //Rendering the necessary components based on the logic
  render() {
    const {
      limit,
      papers,
      totalCount,
      isTableDataLoading,
      currentPage,
      isLoading,
      selectedPapers,
      selectAll,
      isAllReady
    } = this.state;
    
    this.validator.purgeFields();

    return (
      <>
        <ContentWrapper>
          <div className="row justify-content-between align-items-center py-5 mb-3">
            <div className="col-md-6 col-6">
              <h3 className="text-nowrap">Manage All Paper Details</h3>
            </div>
          </div>
          <div className="row align-items-center">
         

              {/* <div className="col-md-3 px-0 filterBySec">
                            <Accordion className="filterAccordion">
                              <AccordionSummary className="filterAccordionSummary" aria-controls="panel1-content" id="panel1-header">
                                  <Box
                                  sx={{ display: "flex", alignItems: "center", gap: "16px" }}
                                  >
                                  <div className="filterpprs mr-5">
                                      <FilterAltIcon />
                                      &emsp;Filter&emsp;
                                      <KeyboardArrowDownIcon
                                        sx={{
                                          transition: "transform 0.3s ease",
                                          cursor: "pointer", 
                                        }}
                                        onClick={(e) => {}}
                                      />
                                  </div>
                                  </Box>
                                  <label>
                                      Start Date&nbsp;:&nbsp;{" "}
                                  <input
                                      type="date"
                                      value={this.state.selectedStartDate?.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3")}
                                      onChange={this.handleStartDateChange}
                                      style={{ padding: "5px", marginRight: "10px", borderRadius: "4px" }}
                                  />
                                  
                                  </label>

                                  <label className='mr-5'>
                                      End Date&nbsp;:&nbsp;{" "}
                                  <input
                                      type="date"
                                      value={this.state.selectedEndDate?.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3")}
                                      onChange={this.handleEndDateChange}
                                      style={{ padding: "5px", borderRadius: "4px" }}
                                  />
                                  
                                  </label>

                                  <Tooltip title="Clear dates">
                                    <IconButton onClick={() => this.clearDateRange()}>
                                      <ClearIcon/>
                                    </IconButton>
                                  </Tooltip>

                                  <Chip
                                      className='mr-5'
                                      label={
                                          <span style={{ fontSize: '1.3rem' }}>
                                              No of Papers:{" "}
                                          <strong>
                                              {this.state.isTableDataLoading ? 
                                                  (
                                                      <CircularProgress size={16} />
                                                  ) : (
                                                      this.state.totalCount
                                                  )
                                              }
                                          </strong>
                                          </span>
                                      }
                                      variant="outlined"
                                      color="primary"
                                  />
                              </AccordionSummary>
                                <Box className="filterCardContainer" sx={{ overflowX: "auto", whiteSpace: "nowrap", display: "flex", padding: "8px", height: '40vh' }}>

                                    {FILTERS.filter((category) => {

                                      return ["Grade", "Subject", "Language", "Chapter", "Year", "Term", "Difficulty", "Status", "Created_By", "Author", "Exam_Category", "Source"].includes(category);
                                    
                                    }).map((category, index) => {

                                    let filterItems = [];
                                    if (category === "Category") {
                                        const categoryCountsMap = new Map(this.state.categoryCounts.map(([category_id, count]) => [category_id, count]));
                                        filterItems = this.state.allCategories?.map((val) => ({
                                            filter: "Category",
                                            name: val.name,
                                            category_id: val.category_id,
                                            dynamic_count: categoryCountsMap.get(val.category_id) || 0,
                                        }));
                                    } else if (category === "Created_By") {
                                        const createdByCountsMap = new Map(this.state.createdByCounts.map(([created_by_id, count]) => [created_by_id, count]));
                                        filterItems = this.state.allCreators?.map((val) => ({
                                            filter: "Created_By",
                                            name: val.first_name + " " + val.last_name,
                                            created_by_id: parseInt(val.created_by_id),
                                            dynamic_count: createdByCountsMap.get(parseInt(val.created_by_id)) || 0,
                                        }));
                                    } else if (category === "Difficulty") {
                                        const difficultyCountsMap = new Map(this.state.difficultyCounts.map(([difficulty_id, count]) => [difficulty_id, count]));
                                        filterItems = this.state.allDifficulties?.map((val) => ({
                                            filter: "Difficulty",
                                            name: val.difficulty_type,
                                            difficulty_id: val.difficulty_id,
                                            dynamic_count: difficultyCountsMap.get(val.difficulty_id) || 0,
                                        }));
                                    } else if (category === "Language") {
                                        const languageCountsMap = new Map(this.state.languageCounts.map(([language_id, count]) => [language_id, count]));
                                        filterItems = this.state.allLanguages?.map((val) => ({
                                            filter: "Language",
                                            name: val.language,
                                            language_id: val.language_id,
                                            dynamic_count: languageCountsMap.get(val.language_id) || 0,
                                        }));
                                    } else if (category === "Subject") {
                                        const subjectCountsMap = new Map(this.state.subjectCounts.map(([subject_id, count]) => [subject_id, count]));
                                        filterItems = this.state.allSubjects?.map((val) => ({
                                            filter: "Subject",
                                            name: val.subject,
                                            subject_id: val.subject_id,
                                            dynamic_count: subjectCountsMap.get(val.subject_id) || 0,
                                        }));
                                    } else if (category === "Author") {
                                        const authorCountsMap = new Map(this.state.authorCounts.map(([author_id, count]) => [author_id, count]));
                                        filterItems = this.state.allAuthors?.map((val) => ({
                                          filter: "Author",
                                          name: val.author,
                                          author_id: val.author_id,
                                          dynamic_count: authorCountsMap.get(val.author_id) || 0,
                                        }));
                                    } else if (category === "Year") {
                                        const yearCountsMap = new Map(this.state.yearCounts.map(([year_id, count]) => [year_id, count]));
                                        filterItems = this.state.allYears?.map((val) => ({
                                            filter: "Year",
                                            name: val.year,
                                            year_id: val.year_id,
                                            dynamic_count: yearCountsMap.get(val.year_id) || 0,
                                        }));
                                    } else if (category === "Grade") {
                                        const gradeCountsMap = new Map(this.state.gradeCounts.map(([grade_id, count]) => [grade_id, count]));
                                        filterItems = this.state.allGrades?.map((val) => ({
                                            filter: "Grade",
                                            name: val.grade,
                                            grade_id: val.grade_id,
                                            dynamic_count: gradeCountsMap.get(val.grade_id) || 0,
                                        }));
                                    } else if (category === "Term") {
                                        const termCountsMap = new Map(this.state.termCounts.map(([term_id, count]) => [term_id, count]));
                                        filterItems = this.state.allTerms?.map((val) => ({
                                            filter: "Term",
                                            name: val.term,
                                            term_id: val.term_id,
                                            dynamic_count: termCountsMap.get(val.term_id) || 0,
                                        }));
                                    } else if (category === "Chapter") {
                                        const chapterCountsMap = new Map(this.state.chapterCounts.map(([chapter_id, count]) => [chapter_id, count]));
                                        filterItems = this.state.allChapters?.map((val) => ({
                                            filter: "Chapter",
                                            name: val.chapter,
                                            chapter_id: val.chapter_id,
                                            dynamic_count: chapterCountsMap.get(val.chapter_id) || 0,
                                        }));
                                    } else if (category === "Status") {
                                        const statusCountsMap = new Map(this.state.statusCounts.map(([status_id, count]) => [status_id, count]));
                                        filterItems = this.state.allAssessmentStatuses?.map((val) => ({
                                          filter: "Status",
                                          name: val.status,
                                          status_id: val.status_id,
                                          dynamic_count: statusCountsMap.get(val.status_id) || 0,
                                        }));
                                    } else if (category === "Exam_Category") {
                                        const examCategoryCountsMap = new Map(this.state.examCategoryCounts.map(([exam_category_id, count]) => [exam_category_id, count]));
                                        filterItems = this.state.allExamCategories?.map((val) => ({
                                          filter: "Exam_Category",
                                          name: val.name,
                                          exam_category_id: val.exam_category_id,
                                          dynamic_count: examCategoryCountsMap.get(val.exam_category_id) || 0,
                                        }));
                                    } else if (category === "Source") {
                                        const sourceCountsMap = new Map(this.state.sourceCounts.map(([source_id, count]) => [source_id, count]));
                                        filterItems = this.state.allSources?.map((val) => ({
                                          filter: "Source",
                                          name: val.source,
                                          source_id: val.source_id,
                                          dynamic_count: sourceCountsMap.get(val.source_id) || 0,
                                        }));
                                    }

                                    return (
                                        <div className="filterCard" key={index} style={{ display: "inline-block", minWidth: "300px", marginRight: "16px", maxHeight: "30vh" }}>
                                        <FormControlLabel
                                            label={category}

                                            sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "flex-start",
                                            "& .MuiFormControlLabel-label": { fontWeight: "600" },
                                            }}
                                            control={
                                            <Checkbox
                                                checked={this.isParentChecked(category)}
                                                indeterminate={this.isParentIndeterminate(category)}
                                                onChange={() => this.handleParentCheckboxChange(category, filterItems)}
                                            />
                                            }
                                        />
                                      <Box sx={{ display: "flex", flexDirection: "column", ml: 3, maxHeight: "20vh", overflowY: "auto" }}>

                                          {filterItems?.map((item) => {

                                          const isChecked = this.state.filterValues.some((selectedItem) =>
                                              selectedItem.filter === item.filter &&
                                              selectedItem[`${item.filter.toLowerCase()}_id`] === item[`${item.filter.toLowerCase()}_id`]
                                          );

                                          return (
                                              <FormControlLabel
                                                key={item[`${category.toLowerCase()}_id`]}
                                                //label={`${item.name} ${` (${item.dynamic_count })`}`}
                                                label={`${item.name} ${item.dynamic_count !== 0 ? ` (${item.dynamic_count})` : ""}`}
                                                //disabled={item.dynamic_count === 0 || this.state.isTableDataLoading}
                                                control={
                                                    <Checkbox
                                                      checked={isChecked}
                                                      onChange={() => this.onSelectFilterMulti(item)}
                                                    />
                                                }
                                              />
                                          )
                                          })}
                                      </Box>
                                    </div>
                                  );
                                  })}
                              </Box>
                              </Accordion>
              </div> */}
            <div className="col-md-4 mt-5">
              {this.state.filterValues && this.state.filterValues.length > 0 && 
                <PaperListChips
                  filterValues={this.state.filterValues}
                  chipClick={this.onSelectFilterMulti}
                  clearAll={this.clearAllFilters}
                />
              }
              </div>
  </div>
          <div className="thepapers-wrapper">
            <div className="col-md-12 px-0">
              <div className="row mt-6">
                <div
                        className={`${
                          this.state.isFilterCollapsed ? "col-md-1" : "col-md-3"
                        } px-0 transition-width`}
                      >
                        <div className="filter-container">
                          {/* Filter Header */}
                          <div
                            className={`${
                              this.state.isFilterCollapsed ? "collapsed-filter" : "expanded-filter"
                            } filter-dynamic`}
                          >
                            <div className="d-flex flex-column flex-md-row flex-wrap align-items-stretch align-items-md-center justify-content-between w-100 gap-2">
                              {/* Filters label (only when collapsed) */}
                              <span
                                className={`${
                                  this.state.isFilterCollapsed ? "d-block" : "d-none"
                                } filter-title`}
                              >
                                Filters
                              </span>

                              {/* Collapse / Expand Button */}
                              <IconButton
                                onClick={() =>
                                  this.setState((prev) => ({
                                    ...prev,
                                    isFilterCollapsed: !prev.isFilterCollapsed,
                                  }))
                                }
                              >
                                {this.state.isFilterCollapsed ? (
                                  <ChevronRightIcon />
                                ) : (
                                  <ChevronLeftIcon />
                                )}
                              </IconButton>
                            </div>
                          </div>

                          {/* Filters Section (visible only when expanded) */}
                          {!this.state.isFilterCollapsed && (
                            <div className="col-md-12 px-0 filterBySec">
                              <PaperFilterLayout
                                userType="MASAD"
                                onFilterChange={this.handleFilterChange}
                                filterKeys={EMPLOYEE_FILTERS.MASAD.ManagePapers}
                                isShowExamStatus={false}
                              />
                            </div>
                          )}
                        </div>
                      </div>
              <div
                      className={`${
                        this.state.isFilterCollapsed ? "col-md-11" : "col-md-9"
                      } transition-width`}
                    >
          <div>
            <StickyCardBody>
            <div className="row mt-5">
              <Form.Group controlId="exampleForm.ControlInput1" style={{ width: "300px" }}>
                <Form.Control
                  type="text"
                  placeholder="Searchh"
                  onChange={this.handleSearch}
                  isInvalid={this.state.searchError}
                  style={{ width: "100%" }}
                  className="col-md-12 col-12"
                />
                {this.state.searchError && (
                  <Form.Control.Feedback type="invalid">
                    Invalid input
                  </Form.Control.Feedback>
                )}
              </Form.Group>
              <div className="col-md-3 d-flex justify-content-end">
                {this.state.selectedPapers.length > 0 && 
                  <Button
                    onClick={() => this.toggleUpdateBulkPaperModal()}
                    className="btn btn-primary btn-sm m-2" 
                    title="Select an/all papers to update selected papers"
                    disabled={this.state.selectedPapers.length === 0 ? true : false} 
                  >
                    Update All Selected Papers
                  </Button>
              }
              </div>
              {/* <div style={{ display: 'inline-flex', alignItems: 'center', marginBottom: '10px' }}>
                <input
                  type="checkbox"
                  id="selectMyPapers"
                  onChange={this.handleSelectMyPapers}
                  checked={this.state.checked}
                  style={{ marginRight: '8px' }}  
                />
                <label htmlFor="selectMyPapers" style={{ margin: 0, cursor: 'pointer' }}>
                  My Papers
                </label>
              </div> */}
              {/* <div style={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end' }}>
                <Form.Group controlId="exampleForm.ControlInput1" style={{ width: "300px" }}>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    onChange={this.handleSearch}
                    isInvalid={this.state.searchError}
                    style={{ width: "100%" }}
                    className="col-md-12 col-12"
                  />
                  {this.state.searchError && (
                    <Form.Control.Feedback type="invalid">
                      Invalid input
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              </div> */}
                <Chip
                        className='mr-5'
                        label={
                            <span style={{ fontSize: '1.3rem' }}>
                                No of Papers:{" "}
                            <strong>
                                {this.state.isTableDataLoading ? 
                                    (
                                        <CircularProgress size={16} />
                                    ) : (
                                        this.state.totalCount
                                    )
                                }
                            </strong>
                            </span>
                        }
                        variant="outlined"
                        color="primary"
                    />
            </div>
            </StickyCardBody>
            {isLoading && (
              <PageSpinner id="show" text="Loading, Please wait!" />
            )}
            {isTableDataLoading ? (
              <div
                className="loading-container"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  height: "auto",
                }}
              >
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </div>
            ) : papers.length > 0 ? (
            <div className="row">
              <div style={{ width: "100%" }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <div style={{ display: "flex", alignItems: "center" }}>
                        <Checkbox
                            checked={selectAll}
                            onChange={this.handleSelectAll}
                            color="primary"
                        />
                        <span>Select All</span>
                        </div>
                      </TableCell>
                      <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("assessment_id")}
                      >
                        Paper Code{" "}
                        {this.state.sort_column === "assessment_id" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                      </TableCell>
                      <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("title")}
                      >
                        Paper Title{" "}
                        {this.state.sort_column === "title" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                      </TableCell>
                      <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("grade_id")}
                      >
                        Paper {gradeText}{" "}
                        {this.state.sort_column === "grade_id" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                      </TableCell>
                      <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("assessment_state")}
                      >
                        Paper Status{" "}
                        {this.state.sort_column === "assessment_state" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                      </TableCell>
                      <TableCell className="thead">Actions</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {papers.map((paperItem) => (
                      <TableRow key={paperItem.assessment_id}>
                        <TableCell>
                            <Checkbox
                              checked={selectedPapers.includes(paperItem.assessment_id)}
                              onChange={() => this.handleSelect(paperItem.assessment_id)}
                              color="primary"
                            />
                        </TableCell>
                        <TableCell className="tData">
                          {"ASMNT" + paperItem.assessment_id} 
                        </TableCell>
                        <TableCell className="tData">
                          {paperItem.title} 
                        </TableCell>
                         <TableCell className="tData">
                          {this.getPaperGrade(paperItem.grade_id)}
                        </TableCell>
                        <TableCell className="tData">
                          <div className={this.getColor(paperItem.assessment_state)}>
                            {paperItem.assessment_state}
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className="btn-group">
                            <Button
                              onClick={() => this.handleViewClick(paperItem)}
                              className="btn btn-icon btn-primary btn-sm m-1 view-assement-btn flaticon-eye-icon"
                              title="View More Details"
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <MaterialCustomTablePagination
                  totalCount = {totalCount}
                  currentPage = {currentPage}
                  limit = {limit}
                  handlePageChange = {this.handlePageChange}
                  handleRowsPerPageChange = {this.handleRowsPerPageChange}
                  handlePageOffsetChange = {this.handlePageOffsetChange}
                  offset = {this.state.offset}
                  rowsPerPageOptions={[5, 10, 20, 25, 50, 75, 100, 150, 200, 250, 300]}
                />
              </div>
            </div>
            ) : (
              <div className="row">
                <div style={{ width: "100%" }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell className="thead">Paper Title</TableCell>
                        <TableCell className="thead">Paper {gradeText}</TableCell>
                        <TableCell className="thead">Paper State</TableCell>
                        <TableCell className="thead">Actions</TableCell>
                      </TableRow>
                    </TableHead>
                  </Table>
                  <div className="text-center mb-5 my-10">
                    <label>No papers are available!</label>
                  </div>
                </div>
              </div>
            )}
          </div>
              </div>
             </div>
           </div>
          </div>
        </ContentWrapper>

        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.showUpdateBulkDetailModal}
          onHide={this.toggleUpdateBulkPaperModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Update Details for All Selected Papers</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="my-5">
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                <Form.Label>Update {gradeText}</Form.Label>
                <Form.Select
                    id="edit-paper-grade"
                    value={this.state.editGradeId}
                    onChange={this.handleChangeGrade}
                    className="form-control"
                    >     
                    <option value={null}>Nothing Selected</option>
                    {this.state.allGrades.map((option, index) => (
                        <option key={index} value={option.grade_id}>
                          {option.grade}
                        </option>
                    ))}
                </Form.Select>
                <Form.Label>Update Subject</Form.Label>
                <Form.Select
                    id="edit-paper-subject"
                    value={this.state.editSubjectId}
                    onChange={this.handleChangeSubject}
                    className="form-control"
                    >
                    <option value={null}>Nothing Selected</option>
                    {this.state.allSubjects.map((option, index) => (
                        <option key={index} value={option.subject_id}>
                          {option.subject}
                        </option>
                    ))}
                </Form.Select>
                <Form.Label>Update Language</Form.Label>
                <Form.Select
                    id="edit-paper-language"
                    value={this.state.editLanguageId}
                    onChange={this.handleChangeLanguage}
                    className="form-control"
                    >     
                    <option value={null}>Nothing Selected</option>
                    {this.state.allLanguages.map((option, index) => (
                        <option key={index} value={option.language_id}>
                          {option.language}
                        </option>
                    ))}
                </Form.Select>
                <Form.Label>Update Exam Category</Form.Label>
                <Form.Select
                    id="edit-paper-exam-category"
                    value={this.state.editExamCategoryId}
                    onChange={this.handleChangeExamCategory}
                    className="form-control"
                    >
                    <option value={null}>Nothing Selected</option>
                    {this.state.allExamCategories.map((option, index) => (
                        <option key={index} value={option.exam_category_id}>
                          {option.name}
                        </option>
                    ))}
                </Form.Select>
                <Form.Label>Update Author</Form.Label>
                <Form.Select
                    id="edit-paper-author"
                    value={this.state.editAuthorId}
                    onChange={this.handleChangeAuthor}
                    className="form-control"
                    >
                    <option value={null}>Nothing Selected</option>
                    {this.state.allAuthors.map((option, index) => (
                        <option key={index} value={option.author_id}>
                          {option.author}
                        </option>
                    ))}
                </Form.Select>
                <Form.Label>Update Source</Form.Label>
                <Form.Select
                    id="edit-paper-source"
                    value={this.state.editSourceId}
                    onChange={this.handleChangeSource}
                    className="form-control"
                    >
                    <option value={null}>Nothing Selected</option>
                    {this.state.allSources.map((option, index) => (
                        <option key={index} value={option.source_id}>
                          {option.source}
                        </option>
                    ))}
                </Form.Select>
                <Form.Label>Update Category</Form.Label>
                <Form.Select
                    id="edit-paper-category"
                    value={this.state.editCategoryId}
                    onChange={this.handleChangeCategory}
                    className="form-control"
                    >     
                    <option value={null}>Nothing Selected</option>
                    {this.state.allCategories.map((option, index) => (
                        <option key={index} value={option.category_id}>
                          {option.name}
                        </option>
                    ))}
                </Form.Select>
                <Form.Label>Update Chapter/Module/Unit</Form.Label>
                <Form.Select
                    id="edit-paper-chapter"
                    value={this.state.editChapterId}
                    onChange={this.handleChangeChapter}
                    className="form-control"
                    >
                    <option value={null}>Nothing Selected</option>
                    {this.state.allChapters.map((option, index) => (
                        <option key={index} value={option.chapter_id}>
                          {option.chapter}
                        </option>
                    ))}
                </Form.Select>
                <Form.Label>Update Difficulty</Form.Label>
                <Form.Select
                    id="edit-paper-difficulty"
                    value={this.state.editDifficultyId}
                    onChange={this.handleChangeDifficulty}
                    className="form-control"
                    >
                    <option value={null}>Nothing Selected</option>
                    {this.state.allDifficulties.map((option, index) => (
                        <option key={index} value={option.difficulty_id}>
                          {option.difficulty_type}
                        </option>
                    ))}
                </Form.Select>
                <Form.Label>Update Year</Form.Label>
                <Form.Select
                    id="edit-paper-year"
                    value={this.state.editYearId}
                    onChange={this.handleChangeYear}
                    className="form-control"
                    >
                    <option value={null}>Nothing Selected</option>
                    {this.state.allYears.map((option, index) => (
                        <option key={index} value={option.year_id}>
                          {option.year}
                        </option>
                    ))}
                </Form.Select>
                <Form.Label>Update Term/Semester</Form.Label>
                <Form.Select
                    id="edit-paper-term"
                    value={this.state.editTermId}
                    onChange={this.handleChangeTerm}
                    className="form-control"
                    >
                    <option value={null}>Nothing Selected</option>
                    {this.state.allTerms.map((option, index) => (
                        <option key={index} value={option.term_id}>
                          {option.term}
                        </option>
                    ))}
                </Form.Select>
                {privilegeEditEnabled && (
                  <>
                  <Form.Label>Update Privilege</Form.Label>
                  <Form.Select
                      id="edit-paper-privilege"
                      value={this.state.editPrivilegeId}
                      onChange={this.handleChangePrivilege}
                      className="form-control"
                      >
                      <option value={null}>Nothing Selected</option>
                      {this.state.allPrivileges.map((option, index) => (
                          <option key={index} value={option.privilege_id}>
                            {option.privilege}
                          </option>
                      ))}
                  </Form.Select>
                </>
                )}
                {/* {isAllReady && (
                  <>
                  <Form.Label>Update Status</Form.Label>
                  <Form.Select
                      id="edit-paper-status"
                      value={this.state.editStatusId}
                      onChange={this.handleChangeStatus}
                      className="form-control"
                      >
                      <option value={null}>Nothing Selected</option>
                      {this.state.allAssessmentStatuses.map((option, index) => (
                          <option key={index} value={option.status_id}>
                            {option.status}
                          </option>
                      ))}
                  </Form.Select>
                </>
                )} */}
                </Form.Group>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="modal-btn"
              variant="primary"
              style={addBtnStyle}
              onClick={this.handleUpdateBulkSubmit}
            >
              Save changes
            </Button>
            <Button
              className="modal-btn"
              id="modal-close-button"
              style={closeBtnStyle}
              onClick={this.handleBulkClose}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          size="lg"
          centered
          show={this.state.showDetailModal}
          onHide={this.toggleDetailModal}
        >
          <ModalHeader>
            <h5 className="modal-title">{this.state.selectedPaper?.title}</h5>
            <Button variant="secondary" onClick={this.toggleDetailModal}>
              Close
            </Button>
          </ModalHeader>
          {this.state.selectedPaper && (
          <ModalBody>
            <ViewForm className="form" id="kt_form">
              {this.state.selectedPaper?.subject_id !== null && 
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Subject :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getPaperSubject(this.state.selectedPaper?.subject_id)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              }
              {this.state.selectedPaper?.language_id !== null && 
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Language :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getPaperLanguage(this.state.selectedPaper?.language_id)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              }
              {this.state.selectedPaper?.exam_category_id !== null && 
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Exam Category :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getPaperExamCategory(this.state.selectedPaper?.exam_category_id)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              } 
              {this.state.selectedPaper?.author_id !== null && 
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Author :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getPaperAuthor(this.state.selectedPaper?.author_id)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              }  
              {this.state.selectedPaper?.source_id !== null && 
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Source :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getPaperSource(this.state.selectedPaper?.source_id)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              }       
              {this.state.selectedPaper?.category_id !== null && 
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Category :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getPaperCategory(this.state.selectedPaper?.category_id)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              }     
              {this.state.selectedPaper?.difficulty_id !== null && 
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Difficulty :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getPaperDifficulty(this.state.selectedPaper?.difficulty_id)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              }
              {this.state.selectedPaper?.chapter_id !== null && 
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Chapter/Module/Unit :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getPaperChapter(this.state.selectedPaper?.chapter_id)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div> 
                </>
              }
              {this.state.selectedPaper?.author_id !== null &&
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Author :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getPaperAuthor(this.state.selectedPaper?.author_id)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              }
              {this.state.selectedPaper?.year_id !== null && !isCMC &&
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Year :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getPaperYear(this.state.selectedPaper?.year_id)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              }
              {this.state.selectedPaper?.term_id !== null && 
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Term/Semester :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getPaperTerm(this.state.selectedPaper?.term_id)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              }
              {this.state.selectedPaper?.first_name !== null && this.state.selectedPaper?.last_name !== null && 
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Created By :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.state.selectedPaper?.first_name + " " + this.state.selectedPaper?.last_name}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              }
              {this.state.selectedPaper?.created_at !== null && 
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Created At :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getCreatedAtLocal(this.state.selectedPaper?.created_at)}
                      </div>
                    </div>
                  </div>
                </>
              }
            </ViewForm>
          </ModalBody>
          )}
        </Modal>
      </>
    );
  }
}
